import LeagueStandingsPage from "../LeagueStandingsPage";

export default function LeaguesPage() {
  return <LeagueStandingsPage publicView />;
}
